import { Directive, ElementRef, HostListener } from '@angular/core';
import { ActualSelected } from './utils';

@Directive({
    selector: '[numberDecimalsDirective]',
    standalone: false
})
export class NumberDecimalsDirective {
  private regex: RegExp;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {
    if (ActualSelected.numDecimals == 2) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,2}$/g);
    }
    if (ActualSelected.numDecimals == 3) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,3}$/g);
    }
    if (ActualSelected.numDecimals == 4) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,4}$/g);
    }
    if (ActualSelected.numDecimals == 5) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,5}$/g);
    }
    if (ActualSelected.numDecimals == 6) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,6}$/g);
    }
    if (ActualSelected.numDecimals == 7) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,7}$/g);
    }
    if (ActualSelected.numDecimals == 8) {
      this.regex = new RegExp(/^\-{0,1}\d*\.?\d{0,8}$/g);
    }
  }

  @HostListener('focus')
  onFocus() {
    const value = this.el.nativeElement.value;
    // Si el valor actual es "0" o "0.0", lo borramos al enfocar
    if (/^0+(\.0+)?$/.test(value)) {
      this.el.nativeElement.value = '';
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const input = this.el.nativeElement;
    const current: string = input.value;
    const position = input.selectionStart;
    const selectionEnd = input.selectionEnd;
    const hasSelection = selectionEnd! > position!;

    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(hasSelection ? selectionEnd : position)
    ].join('');

    // Evitar escribir ceros a la izquierda (ej: 05, 012, etc.)
    // Permitir escribir encima del 0 o si hay selección activa
    const replacingZero =
      hasSelection || (current === '0' && position === 0);

    if (!replacingZero && /^-?0\d/.test(next)) {
      event.preventDefault();
      return;
    }

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
